<div [ngClass]="{ 'vertical-stack-labels': stackLabelsVertically, 'horizontal-list-labels': !stackLabelsVertically }">
  <ng-container *ngFor="let label of viewModel.labelsToDisplay$ | async">
    <app-label-inflator
      [zoom]="zoom"
      [displayLabelInterface]="label | labelInterfaceForLabelPicker: true | async"
      (clearClicked)="handleClearedLabel($event)">
    </app-label-inflator>
  </ng-container>
</div>
